import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateProperties extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Property/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetObjectPropertiesOf extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Property/GetObjectPropertiesBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class DeleteProperty extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Property/DeleteBy");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class UpdateAProperty extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Property/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  CreateProperties,
  GetObjectPropertiesOf,
  DeleteProperty,
  UpdateAProperty,
};
